"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupLabel = void 0;
var PopupLabel;
(function (PopupLabel) {
    PopupLabel["REGISTRATION"] = "Registration";
    PopupLabel["ACCOUNT_DELETED"] = "Account deleted";
    PopupLabel["LOGOUT_SUCCESSFUL"] = "Logout successful";
    PopupLabel["DOI_MISSING"] = "DoImissing";
    PopupLabel["FINAL_CONFIRMATION"] = "FinalConfirmation";
    PopupLabel["LINK_EXPIRATION"] = "LinkExpiration";
    PopupLabel["CHECK_FINAL_CONFIRMATIONMAIL"] = "CheckFinalConfirmationMail";
})(PopupLabel || (exports.PopupLabel = PopupLabel = {}));
//# sourceMappingURL=PopupLabel.js.map